<div *ngFor="let form of formItems;  index as i;">
    <div *ngIf="form.isTable; else isForm">
        <gen-dynamic-form-table
            [data]=lesionsData[i]
            [formId]=form.formId
        ></gen-dynamic-form-table>
    </div>
   <ng-template #isForm>
       <div class="form.cssClass">
        <gen-dynamic-form
            [formData] = lesionsData[i]
            [formName]=form.formId
            [listenToDataChange]="true"
        ></gen-dynamic-form>
       </div>
    </ng-template>

</div>
